import { Check } from "lucide-react";

export type ZustandForm = "raute" | "punkt" | "ring" | "haken";

/** Zustand einer Frist (`fristRechts` in saetze.ts). */
export type FristZustand = "ueberfaellig" | "bald" | "spaeter" | "erledigt";

/** W82 Web-5c (K27, FW12): Form je Zustand wie in der Fristzeile der Welt (Vorlage R11 `.glyph`): überfällig Raute, bald
 *  Punkt, später Ring, erledigt ein Punkt in Mint (die Farbe setzt der Aufrufer über `data-zustand`). Eine Zuordnung für
 *  den Reiter Fristen und die Fristzeile im Dokument. */
const FORMEN: Record<FristZustand, ZustandForm> = { ueberfaellig: "raute", bald: "punkt", spaeter: "ring", erledigt: "punkt" };

export function formFuer(zustand: FristZustand): ZustandForm {
  return FORMEN[zustand];
}

/** Form-zur-Farbe-Regel: überfällig Raute (45 Grad, Ecke 1,5 px), bald Punkt 8 px, später Ring 2 px, erledigt Haken.
 *  Nur Grafik: das Wort steht immer daneben. */
export function Zustand(props: { form: ZustandForm }) {
  if (props.form === "haken") {
    return (
      <span className="zustand" data-form="haken" aria-hidden="true">
        <Check size={14} strokeWidth={1.75} aria-hidden />
      </span>
    );
  }
  return <span className="zustand" data-form={props.form} aria-hidden="true" />;
}

/** Kreis zum Abhaken: 26 in 44, Ring 2 px in der Zustandsfarbe, erledigt gefüllt mit Haken. Der Lesetext kommt vom
 *  Aufrufer (Bestand, etwa „Erledigt“ und „Wieder öffnen“ in seiten/Fristen.tsx). */
export function AbhakKreis(props: { erledigt: boolean; zustand?: "ueberfaellig" | "bald" | "spaeter"; label: string; onUmschalten: () => void; kennung?: string }) {
  return (
    <button
      type="button"
      className="abhaken"
      aria-pressed={props.erledigt}
      aria-label={props.label}
      data-zustand={props.zustand ?? "spaeter"}
      data-testid={props.kennung}
      onClick={props.onUmschalten}
    >
      <span className="abhaken-kreis">{props.erledigt && <Check size={16} strokeWidth={1.75} aria-hidden />}</span>
    </button>
  );
}
